"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customWorkflowFields = void 0;
exports.customWorkflowFields = [
    // NOTE: since assign entity card is dynamic,
    // use taskV2.user instead of assignTask
    // { isCustom: true, value: 'assignTask', label: 'Assign Task' },
    {
        isCustom: true,
        value: 'assignSubTasks',
        label: 'Assign SubTasks (i.e. Approvers)'
    }
];
//# sourceMappingURL=customWorkflowFields.js.map